<i class="p-sortable-column-icon z-sort-icon fa-duotone" [ngClass]="getSortIcon(sortOrder)"></i>
<i *ngIf="isMultiSorted()" class="z-sort-icon-multi fa-solid" [ngClass]="getMultiSortNumber()"></i>
